module.exports = __webpack_public_path__ + "static/img/c5.dc68723.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/success/c5.png
// module id = 9Cn1
// module chunks = 0